import { Component, Input } from "@angular/core";

@Component({
  selector: "data-display-with-tooltip",
  templateUrl: "./data-display-with-tooltip.component.html",
})
export class DataDisplayWithTooltipComponent {
  // General Properties
  @Input() tttBackgroundColor: string = "#555";
  @Input() tttColor: string = "#fff";
  @Input() tttMaxWidth: string;
  @Input() tttMinWidth: string;
  @Input() tttWidth: string = "80px";

  // Positioning
  @Input() tttBottomOffset: string = "-150%";
  @Input() tttLeftOffset: string = "50%";
  @Input() tttRightOffset: string;
  @Input() tttTopOffset: string;

  // Text Appearance
  @Input() tttFontSize: string;
  @Input() tttFontWeight: string;
  @Input() tttLineHeight: string;
  @Input() tttWhiteSpace: string;
  @Input() tttTextAlign: string = "center";

  // Borders
  @Input() tttBorder: string;
  @Input() tttBorderRadius: string = "6px";
  @Input() tttBoxShadow: string;

  // Margin
  @Input() tttMargin: string;
  @Input() tttMarginBottom: string;
  @Input() tttMarginLeft: string = "37px";
  @Input() tttMarginRight: string;
  @Input() tttMarginTop: string;

  // Padding
  @Input() tttPadding: string = "5px 0";
  @Input() tttPaddingBottom: string;
  @Input() tttPaddingLeft: string;
  @Input() tttPaddingRight: string;
  @Input() tttPaddingTop: string;

  constructor() {}
}



// WEBPACK FOOTER //
// ./src/components/data-display-with-tooltip/data-display-with-tooltip.component.ts